import SpaceY from '../../../components/SpaceY';
import {
  MAX_WIDTH_639PX,
  s3CloudFrontUrlEndpoint,
} from '../../../utils/common';
import { useAlertModal } from '../../../utils/hook/hook';
import useClientMediaQuery from '../../../utils/hook/useClientMediaQuery';
import IgnoreParentPadding from '../IgnoreParentPadding';

import MissionDescriptionWrapper from './MissionSectionWrapper';

const MissionThirdSection = ({
  handleTabToSourcing,
}: {
  handleTabToSourcing: (tab?: 0 | 1) => void;
}) => {
  const isMobile = useClientMediaQuery({ query: MAX_WIDTH_639PX });

  const CARD_DATA = [
    {
      index: 1,
      title: (
        <>
          판로를 잃은 농산물을 구출하고
          {isMobile ? <br /> : ' '}
          폐기를 막습니다.
        </>
      ),
      description:
        '개성있는 외형으로 판로를 잃은 농산물, 일시적인 구조 문제로 판로를 잃은 농산물, 공급 과다로 생긴 잉여 농산물들을 산지에서 직접 수매해 합리적인 가격으로 제공합니다.',
    },
    {
      index: 2,
      title: (
        <>
          친환경 생산의 확대로
          <br />
          지속가능한 땅을 늘려나갑니다
        </>
      ),
      description: (
        <>
          생산부터 자연 생태계와 함께 스스로 거칠게 자라길 선택한 친환경
          농산물들을 가치있게 여깁니다.
          <br />
          어글리어스가 모든 농가를 직접 방문하고 생산 환경을 확인해, 친환경
          농산물과 소싱철학에 맞는 농산물들을 우선 소싱합니다.
        </>
      ),
    },
    {
      index: 3,
      title: (
        <>
          플라스틱 없는 포장,
          <br />
          친환경 패키징을 추구합니다
        </>
      ),
      description:
        '농산물의 신선도를 지키는 선에서 최소한의 포장을 끊임없이 실험하고 실천합니다. 종이백과 펄프용기, 생분해 비닐을 사용하고 플라스틱은 지양합니다. 조금 번거롭더라도 우리의 땅과 식탁에 이로운 방향을 선택합니다.',
    },
  ];

  const Card = ({ index, title, description }: (typeof CARD_DATA)[number]) => {
    const { openAlertModal } = useAlertModal();

    const handleOpenModal = () =>
      openAlertModal({
        title: '친환경 농산물이란?',
        content: (
          <>
            환경을 보전하고 소비자에게 보다 안전한 농산물을 공급하기 위해 농약과
            화학비료 등 화학자재를 전혀 사용하지 않거나, 최소량만을 사용하여
            생산한 농산물입니다.
            <br />
            매년 엄격한 현장 실사와 농약검출검사를 통해 정부가 지정한 인증마크를
            획득한 농산물만이 ‘친환경’ 농산물로 분류됩니다.
          </>
        ),
      });

    return (
      <div
        className={`flex flex-col space-y-16px rounded-10px bg-gray-100 py-32px px-20px sm:px-40px ${
          index === 2 ? 'sm:h-408px' : ''
        } ${index === 3 ? 'sm:h-408px' : ''}`}
      >
        <div className="flex-center mx-auto h-32px w-32px rounded-full bg-black">
          <p className="text-16px font-bold text-white">{index}</p>
        </div>
        <h3 className="text-center text-22px font-bold leading-[30.8px] text-gray-800">
          {title}
        </h3>
        <p
          className={`text-18px leading-[28.8px] ${
            index === 1 ? 'sm:text-center' : ''
          }`}
        >
          {description}
        </p>
        {index === 2 && (
          <button onClick={handleOpenModal} type="button">
            <p className="text-center text-16px text-gray-600 underline">
              친환경 농산물이란?
            </p>
          </button>
        )}
      </div>
    );
  };

  const ImageCard = () => {
    return (
      <div className="relative h-382px overflow-hidden rounded-10px sm:h-[408px] ">
        <img
          src={`${s3CloudFrontUrlEndpoint}/mission/soil.png`}
          alt="배추 사진"
          className="h-full w-full object-cover object-center"
        />
        <div
          className="absolute inset-0 z-10 flex items-end justify-center"
          style={{
            background:
              'linear-gradient(0deg, rgba(0, 0, 0, 0.4) 32.46%, rgba(0, 0, 0, 0) 59.55%)',
          }}
        >
          <div>
            <div className="sm:flex sm:flex-col-reverse">
              <p className="text-center text-18px leading-[27px] text-white">
                살아있는 땅은 꿀벌, 곤충, 동물 등<br />
                다양한 생태계가 선순환하는 기반이 됩니다.
              </p>

              <SpaceY height={16} />
              <img
                onClick={() => handleTabToSourcing(1)}
                src={`${s3CloudFrontUrlEndpoint}/mission/sourcing_button.svg`}
                alt="소싱 철학 자세히 알아보기"
                className="mx-auto cursor-pointer"
              />
            </div>
            <SpaceY height={40} />
          </div>
        </div>
      </div>
    );
  };

  const PackageImage = () =>
    isMobile ? (
      <IgnoreParentPadding px={16}>
        <img
          src={`${s3CloudFrontUrlEndpoint}/mission/mo_package_v2.png`}
          alt="포장용기"
        />
      </IgnoreParentPadding>
    ) : (
      <div className="h-408px overflow-hidden rounded-10px border">
        <img
          className="h-full w-full object-cover object-center"
          src={`${s3CloudFrontUrlEndpoint}/mission/mo_package.png`}
          alt="포장용기"
        />
      </div>
    );

  return (
    <>
      <MissionDescriptionWrapper
        headerChildren={
          <>
            생산부터 유통까지{isMobile ? <br /> : ' '}
            환경을 생각합니다
          </>
        }
      >
        <Card {...CARD_DATA[0]} />

        {isMobile ? (
          <>
            <SpaceY height={48} />
            <Card {...CARD_DATA[1]} />

            <SpaceY height={48} />
            <ImageCard />

            <SpaceY height={48} />
            <Card {...CARD_DATA[2]} />

            <SpaceY height={48} />
            <PackageImage />
          </>
        ) : (
          <>
            <SpaceY height={16} />
            <div className="grid grid-cols-2 gap-16px">
              <Card {...CARD_DATA[1]} />
              <ImageCard />
              <PackageImage />
              <Card {...CARD_DATA[2]} />
            </div>
          </>
        )}
      </MissionDescriptionWrapper>
    </>
  );
};

export default MissionThirdSection;
